
const digest = '8968a4a9e36ef29c959cc91e79d9873ac6ba2bbd396f12bf6d249588bfb78196';
const classes = {"itemsWrapper":"_itemsWrapper_19lkk_1","items":"_items_19lkk_1","item":"_item_19lkk_1","title":"_title_19lkk_25","active":"_active_19lkk_31","disabled":"_disabled_19lkk_39"};
const css = `._itemsWrapper_19lkk_1 {
  background-color: #fff;
  border: 1px solid #eaedf3;
  display: flex;
  margin-bottom: 5px;
  overflow-x: auto;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  padding: 6px 12px;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 {
  display: flex;
  flex-direction: column;
  counter-reset: stepper;
  gap: 12px;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 ._item_19lkk_1 {
  padding: 4px 12px;
  background-color: #fff;
  border-radius: 15px;
  border: 1px solid #eaedf3;
  min-width: fit-content;
  cursor: pointer;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 ._item_19lkk_1 ._title_19lkk_25 {
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3e3f42;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 ._item_19lkk_1._active_19lkk_31 {
  background-color: #1d65d8;
  border-color: #1d65d8;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 ._item_19lkk_1._active_19lkk_31 ._title_19lkk_25 {
  color: #ffffff;
  font-weight: 500;
}
._itemsWrapper_19lkk_1 ._items_19lkk_1 ._item_19lkk_1._disabled_19lkk_39 {
  pointer-events: none;
  background: gray;
}
@media (min-width: 576px) {
  ._itemsWrapper_19lkk_1 ._items_19lkk_1 {
    flex-direction: row;
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  